import Vue from 'vue';
import Vuetify from 'vuetify';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: 'fa',
  }
  // breakpoint: {
  //   thresholds: {
  //     xs: 600,
  //     sm: 860,
  //     md: 1366,
  //     lg: 1904,
  //   },
  // }
};

export default new Vuetify(opts);
